<template>
    <div>
        <!-- TABELA -->
        <v-layout v-if="!isNewContract" wrap row xs12>
            <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Pesquisar"
                    single-line
                    hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table
                :headers="headers"
                :search="search"
                rows-per-page-text="Registros por Página"
                :rows-per-page-items="[10, 30, 50, 100]"
                :items="contracts"
                class="elevation-1"
                style="width: 100%"
                :loading="loading"
                :pagination.sync="pagination"
                item-key="contractCode"
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-center">{{ props.item.contractCode }}</td>
                    <td class="text-xs-center">{{ props.item.company.socialName || null }}</td>
                    <td
                        class="text-xs-center"
                    >{{ props.item.client.socialName || props.item.client.name }}</td>
                    <td class="text-xs-center" v-if="!props.item.situation.status">
                        <v-chip small class="font-weight-light"></v-chip>
                    </td>
                    <td class="text-xs-center" v-else>
                        <v-chip
                            small
                            class="font-weight-light"
                            :color="props.item.situation.statusColor"
                        >{{props.item.situation.status}}</v-chip>
                    </td>

                    <td class="justify-center layout px-0">
                        <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                    </td>
                </template>
                <template
                    slot="pageText"
                    slot-scope="props"
                >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
                <template slot="no-data">
                    <strong>{{footerDynamicText}}</strong>
                </template>
                <div slot="no-results" :value="true">
                    <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
                </div>
            </v-data-table>
        </v-layout>
        <!-- TABELA -->

        <!-- NOVO CONTRATO -->
        <v-layout v-else wrap row>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click.prevent="cancelNewContract();" title="Cancelar">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Aprovação Inicial</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        @click.prevent="approve"
                        title="Aprovar Contrato"
                        color="primary"
                        small
                        depressed
                    >
                        Aprovar
                        <v-icon right>check</v-icon>
                    </v-btn>
                    <v-divider vertical class="ml-2 mr-2" inset dark></v-divider>
                    <v-btn
                        @click.prevent="save"
                        title="Salvar Contrato"
                        color="primary"
                        small
                        depressed
                    >
                        Salvar
                        <v-icon right>save</v-icon>
                    </v-btn>
                    <v-btn
                        @click.prevent="download"
                        title="Download Contrato"
                        color="primary"
                        small
                        depressed
                    >
                        Download da Requisição
                        <v-icon right>cloud</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-container fluid grid-list-xl>
                <v-form ref="contractValidation">
                    <v-alert :value="alert" :color="alertType" dismissible class="mb-3">{{msgAlert}}</v-alert>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 py-0>
                            <v-autocomplete
                                label="Empresa"
                                v-model="contract.company"
                                readonly
                                item-value="_id"
                                :items="companies"
                                :item-text="companyText"
                                return-object
                                dense
                                flat
                                box
                                no-data-text="Nenhuma empresa encontrada"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 py-0>
                            <v-autocomplete
                                label="Cliente (Contratante)"
                                readonly
                                v-model="contract.client"
                                :items="clients"
                                item-value="_id"
                                :item-text="clientText"
                                return-object
                                dense
                                flat
                                box
                                no-data-text="Nenhum cliente encontrado"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4 py-0>
                            <!-- Esse dado é a soma dos valores do setor? -->
                            <v-text-field
                                v-model="contract.amount"
                                readonly
                                label="Valor do Contrato (Mês)"
                                box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4 py-0>
                            <v-autocomplete
                                label="Supervisor Responsável"
                                v-model="contract.supervisor"
                                :rules="inputRules"
                                item-value="_id"
                                :items="users"
                                item-text="name"
                                return-object
                                dense
                                flat
                                box
                                no-data-text="Nenhum responsável encontrado"
                            ></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 sm4 py-0>
                            <v-text-field
                                v-model="contract.startDate"
                                readonly
                                label="Início do Periodo"
                                type="date"
                                box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 py-0>
                            <v-text-field
                                v-model="contract.endDate"
                                readonly
                                label="Fim do Periodo"
                                type="date"
                                box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md4 py-0>
                            <v-text-field
                                type="number"
                                v-model="contract.sendDate"
                                :rules="inputRules"
                                label="Dia de Envio"
                                box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs0 md4></v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row wrap>
                        <dialog-supervisor
                            @savedSupervisor="addSupervisorResponsibleInArray"
                            ref="dialogSupervisor"
                        ></dialog-supervisor>
                    </v-layout>
                </v-form>
            </v-container>
            <v-container fluid grid-list-xl>
                <v-layout row wrap>
                    <v-flex xs12 mt-5 mb-3>
                        <v-layout row justify-end>
                            <v-flex xs12>
                                <h2>Fiscal</h2>
                            </v-flex>
                            <v-btn
                                fab
                                dark
                                small
                                color="primary"
                                class="mb-2"
                                @click.prevent="addNewSupervisorResposible"
                            >
                                <v-icon dark>add</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-data-table
                            :headers="supervisorResponsiblesHeaders"
                            :search="search"
                            rows-per-page-text="Registros por Página"
                            :rows-per-page-items="[10, 30, 50, 100]"
                            :items=" contract.client.supervisorResponsibles"
                            class="elevation-1"
                            style="width: 100%"
                            :loading="loading"
                        >
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-center">{{ props.item.name }}</td>
                                <td class="text-xs-center">{{ props.item.role}}</td>
                                <td class="text-xs-center">{{ props.item.phone}}</td>
                                <td class="text-xs-center">{{ props.item.email}}</td>
                                <td class="text-xs-center px-0">
                                    <v-icon
                                        small
                                        class="mr-2"
                                        @click="editSupervisorResponsible(props.item)"
                                    >edit</v-icon>
                                    <v-icon
                                        small
                                        class="mr-2"
                                        @click="$refs.dialogDeleteSupervisor.openDialog(props.item)"
                                    >delete</v-icon>
                                </td>
                            </template>
                            <template slot="no-data">
                                <strong
                                    v-if="quantityItemsError"
                                    class="red--text"
                                >Adicione pelo menos 1 item</strong>
                                <strong v-else>{{footerDynamicText}}</strong>
                            </template>
                            <!--    <div slot="no-results" :value="true">
                <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
                            </div>-->
                        </v-data-table>
                        <alert-delete
                            ref="dialogDeleteSupervisor"
                            @deleteItem="removeSupervisorResponsible"
                        />
                    </v-flex>
                </v-layout>
            </v-container>
            <v-divider></v-divider>
            <v-layout row wrap class="pt-4">
                <v-flex xs12>
                    <v-container fluid grid-list-xl>
                        <v-layout row justify-end>
                            <v-flex xs12>
                                <h2>Setores</h2>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>

                <v-flex xs12>
                    <v-container fluid grid-list-xl>
                        <v-layout row wrap>
                            <v-flex
                                xs12
                                sm6
                                md4
                                v-for="(department, i) in contract.departments"
                                :key="department._id"
                            >
                                <v-list two-line light class="py-0 elevation-2">
                                    <v-list-tile>
                                        <v-list-tile-content
                                            class="descoration"
                                            @click="editDepartment(i, department)"
                                        >
                                            <v-list-tile-title>{{department.name +"-"+department.lastName}}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{department.numberOfEmployees>1?department.numberOfEmployees+' funcionários': department.numberOfEmployees+' funcionário'}}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-divider vertical inset></v-divider>
                                        <v-list-tile-action
                                            class="descoration"
                                            @click="editDepartment(i, department)"
                                        >
                                            <v-icon color="primary" class="pr-2">edit</v-icon>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
        </v-layout>

        <!-- NOVO CONTRATO -->

        <!-- DIALOG EDIÇÃO DE SETOR -->
        <v-layout row justify-center>
            <v-dialog
                v-model="dialogDepartment"
                fullscreen
                persistent
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary" class="elevation-1">
                        <v-btn icon dark @click="closeDialogDepartment" title="Cancelar">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{editDepartmentItem? "Editar Setor":"Novo Setor"}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                @click="saveDepartment"
                                title="Salvar Setor"
                                color="primary"
                                small
                                depressed
                            >
                                Salvar
                                <v-icon right>save</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-layout row wrap px-5>
                        <v-flex xs12>
                            <department
                                @chengedSector="sendAddress"
                                :finalizedContract="true"
                                ref="departmentForm"
                            />
                        </v-flex>
                        <v-flex xs12 mt-5 mb-3>
                            <tables
                                ref="materialTables"
                                :isContractInitialPage="true"
                                :contractFinished="true"
                            />
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-dialog>
        </v-layout>
        <!-- DIALOG EDIÇÃO DE SETOR -->

        <!-- DIALOG LOADING -->
        <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Carregando
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- DIALOG LOADING -->
    </div>
</template>

<script>
// SERVICES //
import BudgetService from '../service/BudgetService.js'
import ContractService from '../service/ContractService.js'
import CompanyService from '../service/CompanyService.js'
import PersonService from '../service/PersonService.js'
import UserService from '../service/UserService.js'
import RequestService from '../service/RequestService.js'
import UtilService from '../service/UtilService.js'
import TypesOfSituations from '../utils/TypesOfSituations.js'
import UtilFormatter from '../utils/UtilFormatter.js'
import MessageFormatterUtil from '../utils/MessageFormatterUtil.js'
import SystemConfigurationService from '../service/SystemConfigurationService'
import Headers from '../data/headers/InitialContractsHeaders'
import CityService from '../service/CityService.js'

// COMPONENTES
import Department from '../components/contract/department/Department'
import Tables from '../components/contract/department/Tables'
import DialogSupervisor from './../components/contract/dialogs/AddNewFiscal'
import AlertDelete from './../components/AlertDelete'

export default {
    components: {
        Department,
        Tables,
        DialogSupervisor,
        AlertDelete,
    },

    data() {
        return {
            quantityItemsError: false,
            firstAccess: true,
            dialogLoading: false,
            dialogImportBudget: false,
            dialogDepartment: false,
            utilFormatter: UtilFormatter,
            isNewContract: true,
            isEditing: false,
            isSearchingAddress: false,
            editSupervisor: false,
            editSupervisorIndex: -1,

            // ALERT //
            msgAlert: '',
            alertType: '',
            alert: false,

            // CAMPOS //
            cities: [],
            cep: '',
            contract: {
                client: {
                    supervisorResponsibles: [],
                },
                situation: {},
                company: {
                    address: {
                        // Endereço
                        cep: '',
                        addressType: '', // Logradouro
                        number: '',
                        district: '',
                        complement: '',
                        city: '',
                        state: '',
                    },
                },
                departments: [],
            },
            companies: [],
            clients: [],
            users: [],
            sheetRemovable: {},
            situations: [],
            removeDialog: false,
            budgets: [],
            departmentIndex: -1,

            // TABELA //
            loading: false,
            contracts: [],
            emptyRecordsText: 'Nenhum registro encontrado',
            emptySearchText: 'Nenhum registro encontrado para',
            search: '',
            editingSheet: {},
            pagination: {
                sortBy: 'contractCode',
                descending: true,
            },
            //Headers
            headers: [],
            supervisorResponsiblesHeaders: [],
            department: {
                professionalCategory: {},
            },
            supervisorResponsibles: [],
            materials: {
                consumables: {
                    items: [],
                },
                equipments: {
                    items: [],
                },
                uniformsAndEPIs: {
                    items: [],
                },
                utensils: {
                    items: [],
                },
            },
            //Rules
            inputRules: [v => !!v || 'Campo Obrigatório'],
            emailRules: [
                v => !!v || 'E-mail é obrigatório',
                v => /.+@.+/.test(v) || 'Insira um e-mail válido',
            ], //Rules
            editDepartmentItem: false,
            sectorType: 'SEDE',
            offices: [],
            unitsOfMeasurement: ['Posto de Serviço', 'M²'],
            agreementsYear: [],
            agreementYearSelected: '',
            agreementYearSelectedItems: [],
            situations: [
                'Aguardando Aprovação',
                'Aprovado',
                'Reprovado',
                'Em Edição',
            ],
            situationEditDisabled: true,
        }
    },

    methods: {
        //###########################PAGINA###########################//

        getHeaders() {
            // esse metodo busca os cabeçalhos de um arquivo externo
            this.headers = Headers.getHeaders()
            this.budgetHeaders = Headers.getBudgetHeaders()
            this.supervisorResponsiblesHeaders = Headers.getSupervisorHeaders()
        },

        init() {
            this.alert = false
            this.contract = {
                client: {
                    supervisorResponsible: {},
                },
                situation: {},
                company: {
                    address: {
                        // Endereço
                        cep: '',
                        addressType: '', // Logradouro
                        number: '',
                        district: '',
                        complement: '',
                        city: '',
                        state: '',
                    },
                },
                departments: [],
            }

            this.loading = false
            this.isEditing = false
            this.dialogLoading = true
            this.isNewContract = false
            this.dialogLoading = false
            this.quantityItemsError = false
            this.editingSheet = {}
            this.findAllContracts()
        },

        companyText: item => `${item.socialName} - ${item.fantasyName}`,

        clientText: item => {
            return item.isLegalPerson
                ? `${item.socialName} - ${item.fantasyName}`
                : `${item.name} - ${item.cpf}`
        },

        amountCalculate(item) {
            let amount = 0
            if (this.depreciation == 'true') {
                amount = item.quantity * item.value * (item.lifetime / 100)
            } else {
                amount = (item.quantity * item.value) / item.lifetime
            }
            return amount
        },
        async findAllContracts() {
            try {
                this.loading = true
                this.contracts = await ContractService.findInitialContracts()
            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
        },

        async fillCompaniesTable() {
            try {
                this.companies = await CompanyService.getCompaniesForSpecificData()
            } catch (error) {
                console.log(error)
            }
        },

        async fillClientsTable() {
            try {
                this.clients = await PersonService.getAll()
            } catch (error) {
                console.log(error)
            }
        },

        async fillUsersTable() {
            try {
                this.users = await UserService.getAll()
            } catch (error) {
                console.log(error)
            }
        },
        showAlert(message, type) {
            this.msgAlert = message
            this.alertType = type
            this.alert = true
        },

        //###########################PAGINA###########################//

        //###########################CONTRATO###########################//
        async addNewContract() {
            this.dialogLoading = true
            if (this.firstAccess) {
                await this.fillCompaniesTable()
                await this.fillClientsTable()
                await this.fillUsersTable()
                this.firstAccess = false
                this.dialogLoading = false
                this.isNewContract = true
            } else {
                this.dialogLoading = false
                this.isNewContract = true
            }
        },

        async findAddressByCep() {
            try {
                if (
                    this.contract.company.address.cep &&
                    this.contract.company.address.cep.length == 8
                ) {
                    this.isSearchingAddress = true
                    this.contract.company.address = await UtilService.findAddressByCep(
                        this.contract.company.address.cep
                    )
                } 
            } catch (error) {
                console.log(error)
            } finally {
                this.isSearchingAddress = false
            }
        },
        cancelNewContract() {
            this.$refs.contractValidation.reset()
            this.init()
        },
        async createRequest() {
            try {
                await RequestService.formatterContractToRequest(this.contract)
                console.log(this.contract)
                this.showAlert('Registro salvo com sucesso', 'success')
                this.save()
            } catch (error) {
                this.showAlert('Erro ao salvar o contrato', 'error')
                console.log(error)
            }
        },
        approve() {
            this.validateQuantityOfSupervisors()
            if (
                this.$refs.contractValidation.validate() &&
                !this.quantityItemsError
            ) {
                this.contract.situation.status = 'Aprovado'
                this.contract.situation.statusColor = '#4CAF50'
                this.createRequest()
            }
        },

        editItem(item) {
            this.isEditing = true
            this.contract = Object.assign({}, item)
            this.addNewContract()
        },

        async save() {
            this.dialogLoading = true

            let errors = ContractService.validade(this.contract)
            if (errors) {
                this.showAlert(
                    MessageFormatterUtil.formatErrorMessage(errors),
                    'error'
                )
                this.dialogLoading = false
                return
            }
            try {
                if (this.isEditing) {
                    await ContractService.update(this.contract)
                    this.showAlert('Registro alterado com sucesso', 'success')
                } else {
                    await ContractService.create(this.contract)
                    this.showAlert('Registro salvo com sucesso', 'success')
                }
            } catch (error) {
                this.showAlert('Erro ao salvar o contrato', 'error')
                console.log(error)
            } finally {
                this.dialogLoading = false
            }
            this.init()
        }, //save()
        //###########################Contrato###########################//

        //###########################SETOR###########################//
        editDepartment(index, item) {
            this.editDepartmentItem = true
            this.$refs.departmentForm.editDepartment(item)
            this.$refs.materialTables.loadTables(item.materials)
            this.departmentIndex = index
            this.dialogDepartment = true
        },
        removeDepartment(item) {
            const index = this.contract.departments.indexOf(item)
            confirm('Are you sure you want to delete this item?') &&
                this.contract.departments.splice(index, 1)
        },

        async saveDepartment(/* department */) {
            let dep = this.$refs.departmentForm.saveDepartment()
            this.department = dep
            this.department.materials = await this.$refs.materialTables.save()
            if (this.editDepartmentItem) {
                this.contract.departments[
                    this.departmentIndex
                ] = this.department
                this.editDepartmentItem = false
            } else {
                this.contract.departments.push(this.department)
            }

            this.closeDialogDepartment()
        },
        sendAddress() {
            this.$refs.departmentForm.setAddress(this.contract.company.address)
        },

        closeDialogDepartment() {
            this.$refs.departmentForm.resetDepartment()
            this.materials = {
                consumables: {
                    items: [],
                },
                equipments: {
                    items: [],
                },
                uniformsAndEPIs: {
                    items: [],
                },
                utensils: {
                    items: [],
                },
            }
            this.$refs.materialTables
            this.departmentIndex = -1
            this.dialogDepartment = false
            this.editDepartmentItem = false
        },
        //###########################SETOR###########################//

        //###########################FISCAL###########################//
        addNewSupervisorResposible() {
            this.$refs.dialogSupervisor.newSupervisor()
        },
        editSupervisorResponsible(item) {
            // edit true;
            const person = JSON.parse(JSON.stringify(item))
            this.editSupervisor = true
            // pegar posição do array
            this.editSupervisorIndex = this.contract.client.supervisorResponsibles.indexOf(
                item
            )
            // chamar metodo do componente para habilitar edição
            this.$refs.dialogSupervisor.editSupervisor(person)
        },

        removeSupervisorResponsible(item) {
            const index = this.contract.client.supervisorResponsibles.indexOf(
                item
            )
            this.contract.client.supervisorResponsibles.splice(index, 1)
        },
        addSupervisorResponsibleInArray(person) {
            if (this.editSupervisor) {
                this.contract.client.supervisorResponsibles.splice(
                    this.editSupervisorIndex,
                    1,
                    person
                )
                this.editSupervisorIndex = -1
                this.editSupervisor = false
            } else {
                this.contract.client.supervisorResponsibles.push(person)
            }
        },

        validateQuantityOfSupervisors() {
            this.contract.client.supervisorResponsibles.length == 0
                ? (this.quantityItemsError = true)
                : (this.quantityItemsError = false)
        },
        //###########################FISCAL###########################//

        async download() {
            // let sheet = await BudgetService.download(this.contract._id)
            // var blob = new Blob([sheet], {
            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"
            // });
            // var url = window.URL.createObjectURL(blob)
            // window.open(url);
        },
    },

    computed: {
        footerDynamicText() {
            let text = this.loading
                ? this.loadingRecordsText
                : this.emptyRecordsText
            return text
        },

        formTitle() {
            return this.isEditing ? 'Editar Item' : 'Novo Item'
        },
    },

    beforeMount() {
        this.init()
        this.getHeaders()
    },
    mounted() {
        this.$refs.materialTables.getHeadersFinishedContract()
    },
    beforeDestroy() {
        this.firstAccess = true
    },
}
</script>

<style>
.descoration {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/InitialContract.vue